var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
		'img-tile',
		{'is-checked': _vm.tile.isChecked},
		{'is-disabled': _vm.tile.isDisabled}
	]},[_c('div',{staticClass:"img-tile__inner"},[_c('div',{staticClass:"img-tile__checkbox"}),_vm._v(" "),_c('div',{staticClass:"img-tile__img",style:(_vm.imgStyleObject)},[_c('img',{staticClass:"visually-hidden",attrs:{"src":_vm.tile.src,"alt":_vm.tile.txt}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }